import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate
} from "react-router-dom";

import { getAuth, onAuthStateChanged } from "firebase/auth";

import Header from "./components/Header";
import Hero from "./components/Hero";
import Info from "./components/Info";
import Features from "./components/Features";
import Footer from "./components/Footer";
import Form from "./components/chatbox";
import About from "./components/About";
import AuthForm from "./components/AuthForm";
import Dashboard from "./components/Dashboard";
import CareersPage from "./components/CareersPage";
import BlogPage from "./components/BlogPage";
import ClientPartners from "./components/ClientPartners";
import AIAgentsPage from "./components/AIAgentsPage";
import TrainingPage from "./components/TrainingPage";
import PaymentPage from "./components/PaymentPage";
import DCMachinesEnroll from "./components/training/DCMachinesEnroll";

import EnergyManagement from "./pages/EnergyManagement/Energy";
import UPSMonitorPage from "./pages/UPSMonitor/UPSMonitorPage";
import Agriculture from "./pages/Agriculture/Agriculture";
import Deployment from "./pages/Deployment/Deployment";
import Livepage from "./pages/Live/Livepage";
import Aboutus from "./pages/Aboutus";

import PricingPage from "./components/PricingPage";
import EnquiryPage from "./components/EnquiryPage";
import FAQ from "./components/FAQ";
import VoiceAssistant from "./components/VoiceAssistant";


// ===============================
// Protected Route
// ===============================

const ProtectedRoute = ({ children }) => {
  const auth = getAuth();

  const [authChecked, setAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(!!user);
      setAuthChecked(true);
    });

    return () => unsubscribe();
  }, [auth]);

  if (!authChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-500"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  return children;
};


// ===============================
// Main Layout
// ===============================

const AppLayout = () => {

  const location = useLocation();

  const isDashboardRoute = location.pathname === "/dashboard";
  const isEnquiryRoute = location.pathname === "/enquiry";
  const isSigninRoute = location.pathname === "/signin";

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {

    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(!!user);
    });

    return () => unsubscribe();

  }, []);

  // Hide header on some pages
  const shouldShowHeader =
    !isDashboardRoute &&
    !isEnquiryRoute;

  return (

    <div className="bg-black text-white overflow-x-hidden">

      {shouldShowHeader && (
        <Header isAuthenticated={isAuthenticated} />
      )}

      <Routes>

        {/* ================= HOME PAGE ================= */}

        <Route
          path="/"
          element={
            <>
              <Hero />


              {/* CLIENT PARTNERS SECTION */}

              <ClientPartners />

              <Info />

              
            

              <FAQ />

              <Form />
            </>
          }
        />

        {/* ================= FEATURES ================= */}

        <Route
          path="/features"
          element={<Features />}
        />

        {/* ================= SIGN IN ================= */}

        <Route
          path="/signin"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <AuthForm />
            )
          }
        />

        {/* ================= DASHBOARD ================= */}

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        {/* ================= CAREERS ================= */}

        <Route
          path="/careers"
          element={<CareersPage />}
        />

        {/* ================= BLOG ================= */}

        <Route
          path="/blog/:id"
          element={<BlogPage />}
        />

        {/* ================= CLIENT PARTNERS ================= */}

        <Route
          path="/client-partners"
          element={<ClientPartners />}
        />

        {/* ================= AI AGENTS ================= */}

        <Route
          path="/aiagents"
          element={<AIAgentsPage />}
        />

        {/* ================= TRAINING ================= */}

        <Route
          path="/training"
          element={<TrainingPage />}
        />

        <Route path="/payment" element={<PaymentPage />} />

        <Route
          path="/training/dc-machines"
          element={<DCMachinesEnroll />}
        />

        {/* ================= PRICING ================= */}

        <Route
          path="/pricing"
          element={<PricingPage />}
        />

        {/* ================= ENQUIRY ================= */}

        <Route
          path="/enquiry"
          element={<EnquiryPage />}
        />

        {/* ================= VOICE ASSISTANT ================= */}

        <Route
          path="/voice-assistant"
          element={<VoiceAssistant />}
        />

        {/* ================= SOLUTIONS ================= */}

        <Route
          path="/solutions/energy-management"
          element={<EnergyManagement />}
        />

        <Route
          path="/solutions/ups-monitor"
          element={<UPSMonitorPage />}
        />

        <Route
          path="/solutions/agriculture-monitor"
          element={<Agriculture />}
        />

        {/* ================= DEPLOYMENT ================= */}

        <Route
          path="/deployment"
          element={<Deployment />}
        />

        {/* ================= LIVE MONITORING ================= */}

        <Route
          path="/live-monitoring"
          element={<Livepage />}
        />


        <Route path="/aboutus" element={<Aboutus />} />

      </Routes>

      {/* ================= FOOTER ================= */}

      {!isSigninRoute && !isDashboardRoute && (
        <>
          <About />
          <Footer />
        </>
      )}

    </div>
  );
};


// ===============================
// App Root
// ===============================

const App = () => {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
};

export default App;